var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unit)?_c('div',{staticClass:"bg-white p-2.5 flex flex-col items-center text-xs"},[_c('span',[_vm._v(_vm._s(_vm.$t('main.ads')))]),_vm._v(" "),_c('AdController',{attrs:{"unit":_vm.unit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }